module.exports = __webpack_public_path__ + "media/images/top/qa/img-gold-c974a52c44c523beb5945c81f2cdb781.png";